'use strict';

const menuItems = document.querySelector('.resources__navigation');
const bannerContainer = document.querySelector('.banner-container');
const header = document.querySelector('.shopify-section-group-header-group');
const footer = document.querySelector('.shopify-section-group-footer-group');
const btnBackToTop = document.querySelector('.button__container--right');
const btnShow = document.querySelector('.show-btt-btn');
const borderedRugEl = document.getElementById('bordered-area-rug-characteristics');
const resNavHeight = menuItems.getBoundingClientRect().height;
const hideNoDealer = document.querySelectorAll('.hide__not-dealer')

if (!dealer) hideNoDealer.forEach(el => el.remove())

const backToTop = function(ent) {
  const [entry] = ent;
  console.log(entry);
  if (!entry.isIntersecting) {
    btnBackToTop.classList.add('hidden');
  } else {
  btnBackToTop.classList.remove('hidden');
  }
};

const btnShowObs = new IntersectionObserver(backToTop, {
  root: null,
  threshold: 0,
});
btnShowObs.observe(btnShow);

// setTimeout(menuItems.classList.remove('sticky'), 2000);

menuItems.addEventListener('click', function(e) {
  if (e.target.classList.contains('menu__title--small')) {
    e.preventDefault();
    const id = e.target.closest('li').getAttribute('data-hash-scroll-id');
    document.querySelector('#'+id).scrollIntoView({behavior: 'smooth'});
    window.history.pushState('', 'Resources', `resources#${id}`);
  }
})

btnBackToTop.addEventListener('click', function(e) {
    header.scrollIntoView({behavior: 'smooth'})
})